import { isValidImages, getFrontImage } from "@grandvisionhq/utils";
const getLineItemImageUrl = (variant) => {
  const images = isValidImages(variant.media?.images) ? variant.media?.images : void 0;
  const imageUrl = getFrontImage(images).url;
  return `${imageUrl}?w=275&fm=jpeg&auto=format`;
};
export {
  getLineItemImageUrl
};
//# sourceMappingURL=get-line-item-image-url.js.map
